import { render, staticRenderFns } from "./RoomsItemStatus.vue?vue&type=template&id=519decf3&scoped=true&"
import script from "./RoomsItemStatus.vue?vue&type=script&lang=js&"
export * from "./RoomsItemStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519decf3",
  null
  
)

export default component.exports